// useConfirmRefresh.js
import { useEffect } from "react";

export default function useConfirmRefresh(enable = true) {
  useEffect(() => {
    if (!enable) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ""; // Required for Chrome to show the prompt
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [enable]);
}
